import apiClient from '../client/api';

export type UpdateProfilePayload = {
  name: string;
};

async function updateProfile(payload: UpdateProfilePayload) {
  const response = await apiClient.put('/profile', payload);
  return response.data;
}

export default { updateProfile };
